// Generated by scripts/generate-forecast-areas.ts. Do not edit by hand: change
// lib/areas/source/* and run `npx tsx scripts/generate-forecast-areas.ts`.
// Slim and edge-safe: the only catalogue file client components and middleware may import.
import type { AreaRouteIndexEntry } from "./types";

export const FORECAST_AREA_CATALOG_VERSION = "db4c3f0a1fbc";

/** Every area: its page sports and parent region. */
export const AREA_ROUTE_INDEX: Readonly<Record<string, AreaRouteIndexEntry>> = {
  "3-vallees": {"pageSports":["piste"],"parent":"tarentaise"},
  "4-vallees": {"pageSports":["piste"],"parent":"valais"},
  "adirondacks": {"pageSports":[],"parent":null},
  "algarve": {"pageSports":["surf"],"parent":"portugal"},
  "alpe-cimbra": {"pageSports":[],"parent":null},
  "alta-valtellina": {"pageSports":[],"parent":null},
  "andorra": {"pageSports":["piste"],"parent":"pyrenees"},
  "aragon-pyrenees": {"pageSports":[],"parent":"pyrenees"},
  "aravis-grand-massif": {"pageSports":["piste"],"parent":null},
  "argentina": {"pageSports":[],"parent":null},
  "aspen-snowmass": {"pageSports":[],"parent":"colorado"},
  "asturias": {"pageSports":[],"parent":"northern-spain"},
  "atlantic-france": {"pageSports":["surf"],"parent":null},
  "auckland": {"pageSports":[],"parent":"nz-north-island"},
  "australia-coast": {"pageSports":["surf"],"parent":null},
  "australian-alps": {"pageSports":["piste"],"parent":null},
  "bahia": {"pageSports":[],"parent":"brazil"},
  "balearic-islands": {"pageSports":[],"parent":null},
  "bali": {"pageSports":["surf"],"parent":"indonesia"},
  "barbados": {"pageSports":[],"parent":"caribbean"},
  "basque-country": {"pageSports":["surf"],"parent":"northern-spain"},
  "bay-of-plenty": {"pageSports":[],"parent":"nz-north-island"},
  "bernese-oberland": {"pageSports":["piste"],"parent":null},
  "boracay-aklan": {"pageSports":[],"parent":"philippines"},
  "brazil": {"pageSports":["surf"],"parent":null},
  "brittany": {"pageSports":[],"parent":"atlantic-france"},
  "bulgaria": {"pageSports":["piste"],"parent":null},
  "caithness": {"pageSports":[],"parent":"scotland-surf"},
  "campiglio-tonale": {"pageSports":[],"parent":null},
  "canadian-rockies": {"pageSports":["piste"],"parent":"western-canada"},
  "canary-islands": {"pageSports":["surf"],"parent":null},
  "cantabria": {"pageSports":[],"parent":"northern-spain"},
  "canterbury-ski": {"pageSports":[],"parent":"new-zealand-ski"},
  "cape-town": {"pageSports":["surf"],"parent":"south-africa"},
  "cape-verde": {"pageSports":[],"parent":null},
  "caribbean": {"pageSports":[],"parent":null},
  "carinthia": {"pageSports":[],"parent":null},
  "cascades": {"pageSports":[],"parent":null},
  "causeway-coast": {"pageSports":[],"parent":"ireland"},
  "ceara": {"pageSports":[],"parent":"brazil"},
  "central-america": {"pageSports":["surf"],"parent":null},
  "central-chile-coast": {"pageSports":[],"parent":null},
  "central-england-reservoirs": {"pageSports":[],"parent":null},
  "central-plateau": {"pageSports":[],"parent":"new-zealand-ski"},
  "central-switzerland": {"pageSports":[],"parent":null},
  "central-valais": {"pageSports":["piste"],"parent":"valais"},
  "chamonix-mont-blanc": {"pageSports":["piste"],"parent":null},
  "charente-maritime": {"pageSports":[],"parent":"atlantic-france"},
  "charleston": {"pageSports":[],"parent":"us-east-coast"},
  "chesapeake-bay": {"pageSports":[],"parent":"us-east-coast"},
  "chile-ski": {"pageSports":[],"parent":null},
  "china": {"pageSports":[],"parent":null},
  "colima": {"pageSports":[],"parent":"mexico"},
  "colorado": {"pageSports":["piste"],"parent":null},
  "columbia-gorge-hood-river": {"pageSports":[],"parent":null},
  "cornwall": {"pageSports":["surf"],"parent":null},
  "costa-de-la-luz": {"pageSports":[],"parent":null},
  "costa-rica-central-pacific": {"pageSports":[],"parent":"central-america"},
  "costa-rica-south-pacific": {"pageSports":[],"parent":"central-america"},
  "czechia": {"pageSports":[],"parent":null},
  "dakar": {"pageSports":[],"parent":null},
  "dakhla-peninsula": {"pageSports":[],"parent":null},
  "denmark": {"pageSports":[],"parent":null},
  "devon": {"pageSports":["surf"],"parent":null},
  "dolomites": {"pageSports":["piste"],"parent":null},
  "dolomites-east": {"pageSports":[],"parent":"dolomites"},
  "dolomites-south": {"pageSports":[],"parent":"dolomites"},
  "dominican-republic": {"pageSports":[],"parent":"caribbean"},
  "dorset": {"pageSports":[],"parent":"south-coast-england"},
  "dublin-bay": {"pageSports":[],"parent":"ireland"},
  "eastern-cape": {"pageSports":[],"parent":"south-africa"},
  "eastern-norway": {"pageSports":["piste"],"parent":"norway-ski"},
  "eastern-sierra": {"pageSports":[],"parent":null},
  "ecuador": {"pageSports":[],"parent":null},
  "egypt-red-sea": {"pageSports":[],"parent":null},
  "el-salvador": {"pageSports":[],"parent":"central-america"},
  "ericeira-lisbon": {"pageSports":["surf"],"parent":"portugal"},
  "espace-san-bernardo": {"pageSports":[],"parent":"tarentaise"},
  "essaouira-coast": {"pageSports":[],"parent":"morocco-coast"},
  "fethiye": {"pageSports":[],"parent":null},
  "fiji": {"pageSports":[],"parent":null},
  "finland": {"pageSports":["piste"],"parent":null},
  "fjord-norway": {"pageSports":[],"parent":"norway-ski"},
  "florida-space-coast": {"pageSports":[],"parent":"us-east-coast"},
  "french-mediterranean": {"pageSports":[],"parent":null},
  "french-pyrenees": {"pageSports":[],"parent":null},
  "fuerteventura": {"pageSports":[],"parent":"canary-islands"},
  "galicia": {"pageSports":[],"parent":"northern-spain"},
  "gauteng-vaal": {"pageSports":[],"parent":"south-africa"},
  "georgia-caucasus": {"pageSports":[],"parent":null},
  "georgia-coast": {"pageSports":[],"parent":"us-east-coast"},
  "germany-coast": {"pageSports":[],"parent":null},
  "germany-ski": {"pageSports":[],"parent":null},
  "gironde": {"pageSports":[],"parent":"atlantic-france"},
  "gold-coast": {"pageSports":["surf"],"parent":"australia-coast"},
  "gran-canaria": {"pageSports":[],"parent":"canary-islands"},
  "granada": {"pageSports":[],"parent":null},
  "graubunden": {"pageSports":["piste"],"parent":null},
  "greece-ski": {"pageSports":[],"parent":null},
  "greek-islands": {"pageSports":[],"parent":null},
  "gstaad-vaud-alps": {"pageSports":["piste"],"parent":null},
  "guadeloupe": {"pageSports":[],"parent":"caribbean"},
  "guanacaste-nicoya": {"pageSports":[],"parent":"central-america"},
  "hautes-alpes": {"pageSports":["piste"],"parent":null},
  "hawaii": {"pageSports":["surf"],"parent":null},
  "hokkaido": {"pageSports":["piste"],"parent":"japan-ski"},
  "hossegor-biarritz": {"pageSports":["surf"],"parent":"atlantic-france"},
  "iceland": {"pageSports":[],"parent":null},
  "india-ski": {"pageSports":[],"parent":null},
  "indonesia": {"pageSports":["surf"],"parent":null},
  "iran": {"pageSports":[],"parent":null},
  "ireland": {"pageSports":["surf"],"parent":null},
  "ireland-south-and-west": {"pageSports":[],"parent":"ireland"},
  "isere-alps": {"pageSports":["piste"],"parent":null},
  "isle-of-wight": {"pageSports":[],"parent":"south-coast-england"},
  "italy-lakes": {"pageSports":[],"parent":null},
  "ixtapa-zihuatanejo": {"pageSports":[],"parent":"mexico"},
  "izu-islands": {"pageSports":[],"parent":"japan-coast"},
  "jamaica": {"pageSports":[],"parent":"caribbean"},
  "japan-coast": {"pageSports":["surf"],"parent":null},
  "japan-ski": {"pageSports":["piste"],"parent":null},
  "jasper": {"pageSports":[],"parent":"western-canada"},
  "java": {"pageSports":[],"parent":"indonesia"},
  "jeju": {"pageSports":[],"parent":null},
  "kent": {"pageSports":[],"parent":null},
  "kerala": {"pageSports":[],"parent":null},
  "kitzbuhel-alps": {"pageSports":["piste"],"parent":"tirol"},
  "kootenays": {"pageSports":[],"parent":"western-canada"},
  "kwazulu-natal": {"pageSports":[],"parent":"south-africa"},
  "kyushu-tanegashima": {"pageSports":[],"parent":"japan-coast"},
  "lake-ontario": {"pageSports":[],"parent":null},
  "lake-tahoe": {"pageSports":["piste"],"parent":null},
  "lanzarote": {"pageSports":[],"parent":"canary-islands"},
  "lebanon": {"pageSports":[],"parent":null},
  "lombok": {"pageSports":[],"parent":"indonesia"},
  "london-essex": {"pageSports":[],"parent":null},
  "los-cabos": {"pageSports":[],"parent":"mexico"},
  "luzon": {"pageSports":[],"parent":"philippines"},
  "madagascar": {"pageSports":[],"parent":null},
  "maine-new-hampshire": {"pageSports":["piste"],"parent":"new-england-ski"},
  "maldives": {"pageSports":[],"parent":null},
  "margaret-river-region": {"pageSports":[],"parent":"australia-coast"},
  "maui": {"pageSports":[],"parent":"hawaii"},
  "maurienne": {"pageSports":[],"parent":null},
  "mauritius": {"pageSports":[],"parent":null},
  "mexico": {"pageSports":["surf"],"parent":null},
  "mirleft-sidi-ifni": {"pageSports":[],"parent":"morocco-coast"},
  "montafon": {"pageSports":[],"parent":null},
  "monte-rosa": {"pageSports":[],"parent":null},
  "morocco-coast": {"pageSports":["surf"],"parent":null},
  "morocco-ski": {"pageSports":[],"parent":null},
  "mozambique": {"pageSports":[],"parent":null},
  "nagano": {"pageSports":["piste"],"parent":"japan-ski"},
  "narvik-riksgransen": {"pageSports":[],"parent":null},
  "netherlands": {"pageSports":[],"parent":null},
  "new-england-ski": {"pageSports":["piste"],"parent":null},
  "new-mexico": {"pageSports":[],"parent":null},
  "new-york-long-island": {"pageSports":[],"parent":"us-east-coast"},
  "new-zealand-ski": {"pageSports":["piste"],"parent":null},
  "newcastle-nsw": {"pageSports":[],"parent":"australia-coast"},
  "nicaragua": {"pageSports":[],"parent":"central-america"},
  "niigata": {"pageSports":[],"parent":"japan-ski"},
  "norcal": {"pageSports":[],"parent":null},
  "noronha": {"pageSports":[],"parent":"brazil"},
  "north-carolina": {"pageSports":[],"parent":"us-east-coast"},
  "north-devon": {"pageSports":["surf"],"parent":"devon"},
  "north-east-england": {"pageSports":[],"parent":null},
  "north-east-scotland": {"pageSports":[],"parent":"scotland-surf"},
  "north-shore-oahu": {"pageSports":["surf"],"parent":"hawaii"},
  "north-wales": {"pageSports":[],"parent":"wales"},
  "northern-rivers": {"pageSports":[],"parent":"australia-coast"},
  "northern-rockies": {"pageSports":[],"parent":null},
  "northern-spain": {"pageSports":["surf"],"parent":null},
  "northland-nz": {"pageSports":[],"parent":"nz-north-island"},
  "norway-coast": {"pageSports":[],"parent":null},
  "norway-ski": {"pageSports":["piste"],"parent":null},
  "nz-north-island": {"pageSports":[],"parent":null},
  "oaxaca": {"pageSports":[],"parent":"mexico"},
  "okanagan": {"pageSports":["piste"],"parent":"western-canada"},
  "orange-county": {"pageSports":[],"parent":"socal"},
  "oregon-coast": {"pageSports":[],"parent":null},
  "panama": {"pageSports":[],"parent":"central-america"},
  "paradiski": {"pageSports":["piste"],"parent":"tarentaise"},
  "pembrokeshire": {"pageSports":["surf"],"parent":"wales"},
  "peniche-nazare": {"pageSports":["surf"],"parent":"portugal"},
  "perth": {"pageSports":[],"parent":"australia-coast"},
  "peru": {"pageSports":[],"parent":null},
  "philippines": {"pageSports":[],"parent":null},
  "piura-coast": {"pageSports":[],"parent":"peru"},
  "portes-du-soleil": {"pageSports":["piste"],"parent":null},
  "porto": {"pageSports":[],"parent":"portugal"},
  "portugal": {"pageSports":["surf"],"parent":null},
  "puerto-rico": {"pageSports":[],"parent":"caribbean"},
  "pyrenees": {"pageSports":["piste"],"parent":null},
  "quebec": {"pageSports":[],"parent":null},
  "queenstown-wanaka": {"pageSports":["piste"],"parent":"new-zealand-ski"},
  "reunion": {"pageSports":[],"parent":null},
  "rhode-island": {"pageSports":[],"parent":"us-east-coast"},
  "rio-de-janeiro": {"pageSports":[],"parent":"brazil"},
  "rio-grande-do-norte": {"pageSports":[],"parent":"brazil"},
  "rio-grande-do-sul": {"pageSports":[],"parent":"brazil"},
  "riviera-nayarit": {"pageSports":[],"parent":"mexico"},
  "romania": {"pageSports":[],"parent":null},
  "sa-west-coast": {"pageSports":[],"parent":"south-africa"},
  "salzburger-land": {"pageSports":["piste"],"parent":null},
  "samoa": {"pageSports":[],"parent":null},
  "san-bernardino-mountains": {"pageSports":[],"parent":null},
  "san-diego": {"pageSports":[],"parent":"socal"},
  "san-francisco-coast": {"pageSports":[],"parent":"norcal"},
  "santa-barbara-ventura": {"pageSports":[],"parent":"socal"},
  "santa-catarina": {"pageSports":[],"parent":"brazil"},
  "santa-cruz-county": {"pageSports":[],"parent":"norcal"},
  "sao-paulo-north-coast": {"pageSports":[],"parent":"brazil"},
  "scotland-ski": {"pageSports":["piste"],"parent":null},
  "scotland-surf": {"pageSports":["surf"],"parent":null},
  "sea-to-sky": {"pageSports":[],"parent":"western-canada"},
  "sella-ronda": {"pageSports":["piste"],"parent":"dolomites"},
  "siargao-surigao": {"pageSports":[],"parent":"philippines"},
  "ski-arlberg": {"pageSports":["piste"],"parent":null},
  "sligo-donegal": {"pageSports":["surf"],"parent":"ireland"},
  "slovenia-ski": {"pageSports":[],"parent":null},
  "socal": {"pageSports":["surf"],"parent":null},
  "south-africa": {"pageSports":["surf"],"parent":null},
  "south-coast-england": {"pageSports":[],"parent":null},
  "south-devon": {"pageSports":[],"parent":"devon"},
  "south-florida": {"pageSports":[],"parent":"us-east-coast"},
  "south-korea-ski": {"pageSports":["piste"],"parent":null},
  "south-wales": {"pageSports":["surf"],"parent":"wales"},
  "southern-colorado": {"pageSports":["piste"],"parent":"colorado"},
  "sri-lanka": {"pageSports":[],"parent":null},
  "straddie": {"pageSports":[],"parent":"australia-coast"},
  "sumatra": {"pageSports":[],"parent":"indonesia"},
  "sumbawa-sumba": {"pageSports":[],"parent":"indonesia"},
  "summit-county": {"pageSports":["piste"],"parent":"colorado"},
  "sunshine-coast": {"pageSports":[],"parent":"australia-coast"},
  "sussex-hampshire": {"pageSports":[],"parent":"south-coast-england"},
  "sweden": {"pageSports":[],"parent":null},
  "sydney": {"pageSports":["surf"],"parent":"australia-coast"},
  "taghazout-agadir": {"pageSports":[],"parent":"morocco-coast"},
  "tahiti": {"pageSports":[],"parent":null},
  "taiwan": {"pageSports":[],"parent":null},
  "tarentaise": {"pageSports":["piste"],"parent":null},
  "tatras": {"pageSports":["piste"],"parent":null},
  "tenerife-island": {"pageSports":[],"parent":"canary-islands"},
  "tignes-val-disere": {"pageSports":["piste"],"parent":"tarentaise"},
  "tirol": {"pageSports":["piste"],"parent":null},
  "tokyo-coast": {"pageSports":["surf"],"parent":"japan-coast"},
  "trondelag": {"pageSports":[],"parent":"norway-ski"},
  "trujillo-coast": {"pageSports":[],"parent":"peru"},
  "trysil-salen": {"pageSports":[],"parent":null},
  "turkey-ski": {"pageSports":[],"parent":null},
  "us-east-coast": {"pageSports":["surf"],"parent":null},
  "utah": {"pageSports":["piste"],"parent":null},
  "val-d-aran": {"pageSports":[],"parent":"pyrenees"},
  "valais": {"pageSports":["piste"],"parent":null},
  "valchiavenna": {"pageSports":[],"parent":null},
  "vermont": {"pageSports":["piste"],"parent":"new-england-ski"},
  "via-lattea": {"pageSports":["piste"],"parent":null},
  "victoria-coast": {"pageSports":[],"parent":"australia-coast"},
  "vietnam": {"pageSports":[],"parent":null},
  "wales": {"pageSports":["surf"],"parent":null},
  "west-scotland-hebrides": {"pageSports":[],"parent":"scotland-surf"},
  "west-tirol": {"pageSports":["piste"],"parent":"tirol"},
  "west-virginia": {"pageSports":[],"parent":null},
  "western-balkans": {"pageSports":[],"parent":null},
  "western-canada": {"pageSports":["piste"],"parent":null},
  "yampa-valley": {"pageSports":[],"parent":"colorado"},
  "yorkshire-coast": {"pageSports":["surf"],"parent":null},
  "zermatt-cervinia": {"pageSports":["piste"],"parent":"valais"},
  "zillertal": {"pageSports":["piste"],"parent":"tirol"},
};

/** Spot slug to leaf area slug. */
export const SPOT_AREA_INDEX: Readonly<Record<string, string>> = {
  "aarhus": "denmark",
  "adelboden": "bernese-oberland",
  "aganoa-samoa": "samoa",
  "alpbach": "kitzbuhel-alps",
  "alpe-dhuez": "isere-alps",
  "alta": "utah",
  "alta-badia": "sella-ronda",
  "amado": "algarve",
  "anakao": "madagascar",
  "anchor-point": "taghazout-agadir",
  "andermatt": "central-switzerland",
  "anglet": "hossegor-biarritz",
  "angourie": "northern-rivers",
  "annapolis": "chesapeake-bay",
  "arabba": "sella-ronda",
  "arapahoe-basin": "summit-county",
  "are": "sweden",
  "arosa-lenzerheide": "graubunden",
  "arrifana": "algarve",
  "arugam-bay": "sri-lanka",
  "aspen": "aspen-snowmass",
  "auckland-waitemata": "auckland",
  "auli": "india-ski",
  "avoca": "sydney",
  "avoriaz": "portes-du-soleil",
  "bad-gastein": "salzburger-land",
  "baisha-bay": "taiwan",
  "bakuriani": "georgia-caucasus",
  "balangan": "bali",
  "baleal": "peniche-nazare",
  "baler": "luzon",
  "bamburgh": "north-east-england",
  "banff-sunshine": "canadian-rockies",
  "bansko": "bulgaria",
  "bantham": "south-devon",
  "baqueira-beret": "val-d-aran",
  "barbados-bathsheba": "barbados",
  "bardonecchia": "via-lattea",
  "barra-de-la-cruz": "oaxaca",
  "beidahu": "china",
  "bells-beach": "victoria-coast",
  "belmont-lake-macquarie": "newcastle-nsw",
  "bialka-tatrzanska": "tatras",
  "biarritz": "hossegor-biarritz",
  "big-bear": "san-bernardino-mountains",
  "big-sky": "northern-rockies",
  "big-white": "okanagan",
  "bigbury": "south-devon",
  "bingin": "bali",
  "biscayne-bay": "south-florida",
  "blacks-beach": "san-diego",
  "bloubergstrand": "cape-town",
  "bocas-del-toro": "panama",
  "bolinas": "san-francisco-coast",
  "boracay": "boracay-aklan",
  "bormio": "alta-valtellina",
  "borovets": "bulgaria",
  "bournemouth": "dorset",
  "bracklesham": "sussex-hampshire",
  "breckenridge": "summit-county",
  "brighton-uk": "sussex-hampshire",
  "brimms-ness": "caithness",
  "bude-summerleaze": "cornwall",
  "bull-bay": "jamaica",
  "bundoran": "sligo-donegal",
  "burleigh-heads": "gold-coast",
  "burnham-on-crouch": "london-essex",
  "cabarete": "dominican-republic",
  "cairngorm": "scotland-ski",
  "camel-estuary": "cornwall",
  "canazei": "sella-ronda",
  "canggu": "bali",
  "cannon-beach": "oregon-coast",
  "capbreton": "hossegor-biarritz",
  "carcavelos": "ericeira-lisbon",
  "cardrona": "queenstown-wanaka",
  "carsington-water": "central-england-reservoirs",
  "caswell": "south-wales",
  "cauterets": "french-pyrenees",
  "cayton-bay": "yorkshire-coast",
  "cedars": "lebanon",
  "cerro-castor": "argentina",
  "cerro-catedral": "argentina",
  "cervinia": "zermatt-cervinia",
  "chamonix": "chamonix-mont-blanc",
  "champery": "portes-du-soleil",
  "chamrousse": "isere-alps",
  "changbaishan": "china",
  "chapel-porth": "cornwall",
  "chapelco": "argentina",
  "chatel": "portes-du-soleil",
  "chicama": "trujillo-coast",
  "chichester-harbour": "sussex-hampshire",
  "cimaja": "java",
  "cloudbreak": "fiji",
  "cocoa-beach": "florida-space-coast",
  "columbia-gorge": "columbia-gorge-hood-river",
  "compton-bay": "isle-of-wight",
  "constantine-bay": "cornwall",
  "copper-mountain": "summit-county",
  "coronet-peak": "queenstown-wanaka",
  "corralco": "chile-ski",
  "cortina-dampezzo": "dolomites-east",
  "costa-da-caparica": "ericeira-lisbon",
  "courchevel": "3-vallees",
  "courmayeur": "chamonix-mont-blanc",
  "crans-montana": "central-valais",
  "crantock": "cornwall",
  "crested-butte": "southern-colorado",
  "croyde": "north-devon",
  "crystal-mountain-wa": "cascades",
  "dakar-yoff": "dakar",
  "dakhla": "dakhla-peninsula",
  "davos": "graubunden",
  "deba": "basque-country",
  "dee-why": "sydney",
  "deer-valley": "utah",
  "desert-point": "lombok",
  "dizin": "iran",
  "dover": "kent",
  "dun-laoghaire": "dublin-bay",
  "dungeons": "cape-town",
  "dunnet-bay": "caithness",
  "durban-bay-of-plenty": "kwazulu-natal",
  "easkey": "sligo-donegal",
  "el-confital": "gran-canaria",
  "el-gouna": "egypt-red-sea",
  "el-palmar": "costa-de-la-luz",
  "el-quemao": "lanzarote",
  "el-sunzal": "el-salvador",
  "el-tunco": "el-salvador",
  "elands-bay": "sa-west-coast",
  "engelberg": "central-switzerland",
  "eoropie": "west-scotland-hebrides",
  "erciyes": "turkey-ski",
  "ericeira": "ericeira-lisbon",
  "essaouira": "essaouira-coast",
  "exe-estuary": "south-devon",
  "falls-creek": "australian-alps",
  "feldberg": "germany-ski",
  "fernando-de-noronha": "noronha",
  "filey": "yorkshire-coast",
  "flaine": "aravis-grand-massif",
  "florianopolis": "santa-catarina",
  "folgaria": "alpe-cimbra",
  "folly-beach": "charleston",
  "formigal": "aragon-pyrenees",
  "fornells-bay": "balearic-islands",
  "fraserburgh": "north-east-scotland",
  "freshwater-west": "pembrokeshire",
  "fuerteventura-cotillo": "fuerteventura",
  "furano": "hokkaido",
  "g-land": "java",
  "garmisch": "germany-ski",
  "garopaba": "santa-catarina",
  "geilo": "eastern-norway",
  "getxo": "basque-country",
  "glencoe": "scotland-ski",
  "glenshee": "scotland-ski",
  "gordons-bay": "cape-town",
  "gracetown": "margaret-river-region",
  "grafham-water": "central-england-reservoirs",
  "gran-canaria-confital": "gran-canaria",
  "grandvalira": "andorra",
  "grimentz": "central-valais",
  "gstaad": "gstaad-vaud-alps",
  "guadeloupe-moule": "guadeloupe",
  "gudauri": "georgia-caucasus",
  "guethary": "hossegor-biarritz",
  "guincho": "ericeira-lisbon",
  "gulmarg": "india-ski",
  "gwithian": "cornwall",
  "hafjell": "eastern-norway",
  "hakuba": "nagano",
  "hamble-river": "sussex-hampshire",
  "harlyn-bay": "cornwall",
  "hayling-island": "sussex-hampshire",
  "heavenly": "lake-tahoe",
  "hemsedal": "eastern-norway",
  "high1": "south-korea-ski",
  "hintertux": "zillertal",
  "hiriketiya": "sri-lanka",
  "hochzillertal": "zillertal",
  "hoddevik": "norway-coast",
  "honolua-bay": "maui",
  "hookipa": "maui",
  "hossegor": "hossegor-biarritz",
  "hotham": "australian-alps",
  "huanchaco": "trujillo-coast",
  "huntington-beach": "orange-county",
  "hyeres": "french-mediterranean",
  "ichinomiya": "tokyo-coast",
  "imsouane": "taghazout-agadir",
  "inch-beach": "ireland-south-and-west",
  "ischgl": "west-tirol",
  "itacare": "bahia",
  "izu": "tokyo-coast",
  "jackson-hole": "northern-rockies",
  "jahorina": "western-balkans",
  "jasna": "tatras",
  "jaws-peahi": "maui",
  "jay-peak": "vermont",
  "jeffreys-bay": "eastern-cape",
  "jeju-jungmun": "jeju",
  "jericoacoara": "ceara",
  "joss-bay": "kent",
  "kartalkaya": "turkey-ski",
  "keramas": "bali",
  "keystone": "summit-county",
  "kicking-horse": "canadian-rockies",
  "kiel": "germany-coast",
  "killington": "vermont",
  "kimmeridge": "dorset",
  "kingston-ontario": "lake-ontario",
  "kiroro": "hokkaido",
  "kirra": "gold-coast",
  "kitzbuhel": "kitzbuhel-alps",
  "kolasin": "western-balkans",
  "kommetjie": "cape-town",
  "kopaonik": "western-balkans",
  "kovalam": "kerala",
  "kranjska-gora": "slovenia-ski",
  "kronplatz": "dolomites-east",
  "krui": "sumatra",
  "kvitfjell": "eastern-norway",
  "la-clusaz": "aravis-grand-massif",
  "la-grave": "hautes-alpes",
  "la-graviere": "hossegor-biarritz",
  "la-jolla-cove": "san-diego",
  "la-parva": "chile-ski",
  "la-plagne": "paradiski",
  "la-rochelle": "charente-maritime",
  "la-rosiere": "espace-san-bernardo",
  "la-santa": "lanzarote",
  "la-thuile": "espace-san-bernardo",
  "la-torche": "brittany",
  "la-union": "luzon",
  "laax": "graubunden",
  "lacanau": "gironde",
  "lagos": "algarve",
  "lahinch": "ireland-south-and-west",
  "lake-garda": "italy-lakes",
  "lake-louise": "canadian-rockies",
  "lakey-peak": "sumbawa-sumba",
  "langland": "south-wales",
  "laniakea": "north-shore-oahu",
  "lanuza": "siargao-surigao",
  "lanzarote-famara": "lanzarote",
  "largs": "west-scotland-hebrides",
  "las-lenas": "argentina",
  "le-grand-bornand": "aravis-grand-massif",
  "lech-zurs": "ski-arlberg",
  "lennox-head": "northern-rivers",
  "les-arcs": "paradiski",
  "les-cavaliers": "hossegor-biarritz",
  "les-contamines": "chamonix-mont-blanc",
  "les-deux-alpes": "isere-alps",
  "les-diablerets": "gstaad-vaud-alps",
  "les-gets": "portes-du-soleil",
  "les-houches": "chamonix-mont-blanc",
  "les-menuires": "3-vallees",
  "les-saisies": "chamonix-mont-blanc",
  "leucate": "french-mediterranean",
  "levi": "finland",
  "livigno": "alta-valtellina",
  "llandegfedd": "south-wales",
  "llangennith": "south-wales",
  "lobitos": "piura-coast",
  "lombok-kuta": "lombok",
  "loon": "maine-new-hampshire",
  "lusty-glaze": "cornwall",
  "machrihanish": "west-scotland-hebrides",
  "madarao": "nagano",
  "madesimo": "valchiavenna",
  "madonna-di-campiglio": "campiglio-tonale",
  "mammoth-mountain": "eastern-sierra",
  "mancora": "piura-coast",
  "manorbier": "pembrokeshire",
  "maresias": "sao-paulo-north-coast",
  "margaret-river": "margaret-river-region",
  "marmot-basin": "jasper",
  "maroubra": "sydney",
  "masella": "andorra",
  "matosinhos": "porto",
  "mavericks": "san-francisco-coast",
  "mayrhofen": "zillertal",
  "medemblik": "netherlands",
  "medewi": "bali",
  "megeve": "chamonix-mont-blanc",
  "menai-strait": "north-wales",
  "mentawai": "sumatra",
  "merewether": "newcastle-nsw",
  "meribel": "3-vallees",
  "mirleft": "mirleft-sidi-ifni",
  "miyazaki": "kyushu-tanegashima",
  "mont-sainte-anne": "quebec",
  "montanita": "ecuador",
  "monterosa": "monte-rosa",
  "montgenevre": "via-lattea",
  "morzine": "portes-du-soleil",
  "mount-maunganui": "bay-of-plenty",
  "mt-bachelor": "cascades",
  "mt-buller": "australian-alps",
  "mt-hutt": "canterbury-ski",
  "mui-ne": "vietnam",
  "muizenberg": "cape-town",
  "muju": "south-korea-ski",
  "mullaghmore": "sligo-donegal",
  "mundaka": "basque-country",
  "murren": "bernese-oberland",
  "myoko-kogen": "niigata",
  "myrkdalen": "fjord-norway",
  "naeba": "niigata",
  "narrabeen": "sydney",
  "narvik": "narvik-riksgransen",
  "nassfeld": "carinthia",
  "nazare": "peniche-nazare",
  "nendaz": "4-vallees",
  "nevis-range": "scotland-ski",
  "new-smyrna": "florida-space-coast",
  "newgale": "pembrokeshire",
  "newport-ri": "rhode-island",
  "newquay-fistral": "cornwall",
  "ngor-ouakam": "dakar",
  "nias": "sumatra",
  "nihiwatu": "sumbawa-sumba",
  "niijima": "izu-islands",
  "niseko": "hokkaido",
  "noosa": "sunshine-coast",
  "norefjell": "eastern-norway",
  "north-male-atoll": "maldives",
  "north-stradbroke": "straddie",
  "northstar": "lake-tahoe",
  "nosara": "guanacaste-nicoya",
  "obergurgl": "west-tirol",
  "oberstdorf": "germany-ski",
  "obertauern": "salzburger-land",
  "ocean-beach-sf": "san-francisco-coast",
  "ohau": "canterbury-ski",
  "oludeniz": "fethiye",
  "oppdal": "trondelag",
  "ordino-arcalis": "andorra",
  "oukaimeden": "morocco-ski",
  "outer-banks": "north-carolina",
  "pacific-city": "oregon-coast",
  "padang-padang": "bali",
  "palandoken": "turkey-ski",
  "palisades-tahoe": "lake-tahoe",
  "palma-mallorca": "balearic-islands",
  "pamporovo": "bulgaria",
  "panorama": "canadian-rockies",
  "pantin": "galicia",
  "park-city": "utah",
  "parnassos": "greece-ski",
  "pascuales": "colima",
  "passo-tonale": "campiglio-tonale",
  "pavones": "costa-rica-south-pacific",
  "peniche-supertubos": "peniche-nazare",
  "perisher": "australian-alps",
  "perranporth": "cornwall",
  "phillip-island": "victoria-coast",
  "phoenix-park": "south-korea-ski",
  "pichilemu": "central-chile-coast",
  "piha": "auckland",
  "pipeline-oahu": "north-shore-oahu",
  "pitsford-water": "central-england-reservoirs",
  "playa-grande-cr": "guanacaste-nicoya",
  "playa-hermosa-cr": "costa-rica-central-pacific",
  "poiana-brasov": "romania",
  "polzeath": "cornwall",
  "ponta-preta": "cape-verde",
  "popova-sapka": "western-balkans",
  "popoyo": "nicaragua",
  "porthleven": "cornwall",
  "porthmeor": "cornwall",
  "porthtowan": "cornwall",
  "portillo": "chile-ski",
  "portrush": "causeway-coast",
  "praa-sands": "cornwall",
  "praia-da-pipa": "rio-grande-do-norte",
  "puerto-escondido": "oaxaca",
  "punta-de-mita": "riviera-nayarit",
  "putsborough": "north-devon",
  "puy-saint-vincent": "hautes-alpes",
  "pwllheli": "north-wales",
  "queenstown-remarkables": "queenstown-wanaka",
  "raglan": "auckland",
  "razo": "galicia",
  "red-mountain": "kootenays",
  "rest-bay": "south-wales",
  "restaurants-namotu": "fiji",
  "revelstoke": "okanagan",
  "reykjanes": "iceland",
  "rhodes": "greek-islands",
  "ribeira-dilhas": "ericeira-lisbon",
  "riksgransen": "narvik-riksgransen",
  "rincon": "santa-barbara-ventura",
  "rincon-pr": "puerto-rico",
  "risoul": "hautes-alpes",
  "rockaway-beach": "new-york-long-island",
  "ruapehu": "central-plateau",
  "ruka": "finland",
  "runswick-bay": "yorkshire-coast",
  "rusutsu": "hokkaido",
  "rutland-water": "central-england-reservoirs",
  "saalbach": "salzburger-land",
  "saas-fee": "central-valais",
  "sagres": "algarve",
  "saint-gervais": "chamonix-mont-blanc",
  "saint-lary": "french-pyrenees",
  "saint-leu": "reunion",
  "sainte-foy": "tignes-val-disere",
  "salen": "trysil-salen",
  "salinas": "asturias",
  "salla": "finland",
  "saltburn": "yorkshire-coast",
  "san-francisco-bay": "san-francisco-coast",
  "san-jose-del-cabo": "los-cabos",
  "san-martino": "dolomites-south",
  "san-sebastian": "basque-country",
  "sandringham-melbourne": "victoria-coast",
  "sandsend": "yorkshire-coast",
  "sandycove": "dublin-bay",
  "santa-catalina": "panama",
  "santa-cruz": "santa-cruz-county",
  "santa-cruz-portugal": "peniche-nazare",
  "santa-teresa": "guanacaste-nicoya",
  "saquarema": "rio-de-janeiro",
  "saunton": "north-devon",
  "sauze-doulx": "via-lattea",
  "sayulita": "riviera-nayarit",
  "scarborough": "yorkshire-coast",
  "scarborough-au": "perth",
  "schladming": "salzburger-land",
  "seaburn": "north-east-england",
  "sebastian-inlet": "florida-space-coast",
  "seignosse": "hossegor-biarritz",
  "selva-val-gardena": "sella-ronda",
  "sennen": "cornwall",
  "serfaus-fiss-ladis": "west-tirol",
  "serre-chevalier": "hautes-alpes",
  "sestriere": "via-lattea",
  "shiga-kogen": "nagano",
  "shipwreck-bay": "northland-nz",
  "shonan": "tokyo-coast",
  "siargao-cloud-9": "siargao-surigao",
  "sidi-kaouki": "essaouira-coast",
  "sierra-nevada": "granada",
  "silver-star": "okanagan",
  "silvretta-montafon": "montafon",
  "simeulue": "sumatra",
  "sinaia": "romania",
  "skiwelt": "kitzbuhel-alps",
  "snapper-rocks": "gold-coast",
  "snowbasin": "utah",
  "snowbird": "utah",
  "snowmass": "aspen-snowmass",
  "snowshoe": "west-virginia",
  "solden": "west-tirol",
  "solitude": "utah",
  "somo": "cantabria",
  "sopela": "basque-country",
  "spindleruv-mlyn": "czechia",
  "st-anton": "ski-arlberg",
  "st-moritz": "graubunden",
  "steamboat": "yampa-valley",
  "stowe": "vermont",
  "strandhill": "sligo-donegal",
  "stubai": "west-tirol",
  "sugarbush": "vermont",
  "sugarloaf": "maine-new-hampshire",
  "sun-valley": "northern-rockies",
  "sunday-river": "maine-new-hampshire",
  "sunset-beach": "north-shore-oahu",
  "sydney-harbour": "sydney",
  "table-bay-cape-town": "cape-town",
  "taghazout": "taghazout-agadir",
  "taitung": "taiwan",
  "tamarin-bay": "mauritius",
  "tanegashima": "kyushu-tanegashima",
  "taos": "new-mexico",
  "tarifa": "costa-de-la-luz",
  "teahupoo": "tahiti",
  "teine": "hokkaido",
  "telluride": "southern-colorado",
  "tenerife": "tenerife-island",
  "the-lecht": "scotland-ski",
  "the-wedge": "orange-county",
  "thredbo": "australian-alps",
  "thulusdhoo": "maldives",
  "thurso-east": "caithness",
  "tignes": "tignes-val-disere",
  "tiree": "west-scotland-hebrides",
  "tofo": "mozambique",
  "tomamu": "hokkaido",
  "torquay": "victoria-coast",
  "torres": "rio-grande-do-sul",
  "tramore": "ireland-south-and-west",
  "treble-cone": "queenstown-wanaka",
  "tremblant": "quebec",
  "trestles": "orange-county",
  "troncones": "ixtapa-zihuatanejo",
  "trysil": "trysil-salen",
  "tsurigasaki": "tokyo-coast",
  "tybee-island": "georgia-coast",
  "tynemouth": "north-east-england",
  "ubatuba": "sao-paulo-north-coast",
  "uludag": "turkey-ski",
  "uluwatu": "bali",
  "unstad": "norway-coast",
  "vaal-dam": "gauteng-vaal",
  "vail": "summit-county",
  "val-di-fiemme": "dolomites-south",
  "val-disere": "tignes-val-disere",
  "val-thorens": "3-vallees",
  "valle-nevado": "chile-ski",
  "vallnord-pal": "andorra",
  "valloire": "maurienne",
  "varkala": "kerala",
  "vemdalen": "sweden",
  "verbier": "4-vallees",
  "villars": "gstaad-vaud-alps",
  "vliho-bay": "greek-islands",
  "vogel": "slovenia-ski",
  "voss": "fjord-norway",
  "waimea-bay": "north-shore-oahu",
  "warth-schrocken": "ski-arlberg",
  "watergate-bay": "cornwall",
  "weligama": "sri-lanka",
  "welsh-harp": "london-essex",
  "wengen-grindelwald": "bernese-oberland",
  "weymouth-portland": "dorset",
  "whistler": "sea-to-sky",
  "whiteface": "adirondacks",
  "whitesands": "pembrokeshire",
  "whitewater": "kootenays",
  "whitstable": "kent",
  "widemouth-bay": "cornwall",
  "winter-park": "summit-county",
  "winterberg": "germany-ski",
  "wolf-creek": "southern-colorado",
  "woolacombe": "north-devon",
  "wrightsville-beach": "north-carolina",
  "yllas": "finland",
  "yongpyong": "south-korea-ski",
  "zakopane": "tatras",
  "zarautz": "basque-country",
  "zell-am-see": "salzburger-land",
  "zermatt": "zermatt-cervinia",
  "zhangjiakou": "china",
};
